module.exports = "/_next/static/images/2b4fb5b58541210c33cdcec5edae67f5-nu-card-xs@1x.jpg.webp";